import React from "react";
//#region redux
import { useDispatch } from "react-redux";
import { personSalaryReportCompleted, personSalaryReportUpdated } from "store/actions/personSalaryActions";
//#endregion
//#region types
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { PersonSalaryFooterProps } from "models/propTypes/salaryPropTypes";
//#endregion
//#region components
import { useSalaryService } from "serviceHooks";
import { PageFooter } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const PersonSalaryFooter: React.FC<PersonSalaryFooterProps> = (props) => {
  const salaryService = useSalaryService();
  const { selected, reloadHandler, disableSuccessMessages } = props;

  const dispatch = useDispatch();

  const onSalaryEntriesAccept = () => {
    return salaryService.approvePersonSalary(selected);
  };

  const onAcceptSuccess = () => {
    reloadHandler &&
      reloadHandler((item) => {
        if (item?.rows?.length) {
          dispatch(personSalaryReportUpdated(item));
        } else {
          dispatch(personSalaryReportCompleted(0));
        }
      });
  };

  return (
    <PageFooter
      actions={[
        {
          text: `${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Approve)}${
            selected.length > 0 ? ` (${selected.length})` : ""
          }`,
          onClick: onSalaryEntriesAccept,
          type: StyleEnums.DisplayType.Success,
          successMessage: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Salary.SubmitSuccessMessage),
          isDisabled: selected.length === 0,
          onActionSuccess: onAcceptSuccess,
        },
      ]}
      disableSuccessMessages={disableSuccessMessages}
    />
  );
};

export default PersonSalaryFooter;
